'use client';

import { useLocalStorage } from 'usehooks-ts';
import { createContext } from 'react';

// in the future these might want to be more complex objects (if more filters get added to each tab etc)
interface MultiGroupContextValue {
  groupFilterIds: string[] | null;
  updateGroupFilterIds: (groupIds: string[] | null) => void;
  groupStringFilter: string;
  updateGroupStringFilter: (filter: string) => void;
}

export const MultiGroupContext = createContext<MultiGroupContextValue>({
  groupFilterIds: null,
  updateGroupFilterIds: () => {
    return null;
  },
  groupStringFilter: '',
  updateGroupStringFilter: () => {
    return null;
  },
});

interface MultiGroupFilteredGroupsContextProviderProps {
  userId: string;
  children: React.ReactNode;
}

export const MultiGroupContextProvider = ({
  userId,
  children,
}: MultiGroupFilteredGroupsContextProviderProps) => {
  const [groupIds, setGroupIds] = useLocalStorage<string[] | null>(
    `multigroup-group-filter-ids:${userId}`,
    [],
  );

  const [groupString, setGroupString] = useLocalStorage<string>(
    `multigroup-group-string-filter:${userId}`,
    '',
  );

  return (
    <MultiGroupContext.Provider
      value={{
        groupFilterIds: groupIds as string[],
        updateGroupFilterIds: (groupIds: string[] | null) => {
          setGroupIds(groupIds);
        },
        groupStringFilter: groupString as string,
        updateGroupStringFilter: (filterString: string) => {
          setGroupString(filterString);
        },
      }}
    >
      {children}
    </MultiGroupContext.Provider>
  );
};
